import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import * as moment from 'moment';

@Component({
  selector: 'app-modal-month',
  templateUrl: './modal-month.component.html',
  styleUrls: ['./modal-month.component.scss']
})
export class ModalMonthComponent implements OnInit {
  @Output() emitData = new EventEmitter();

  isShowYears = true;

  private selectedDate: any;

  constructor(
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
  }

  onChange(event: { monthIndex: number, year: number }) {
    const year = event.year.toString();
    const monthIndex = event.monthIndex;
    const month = moment().month(event.monthIndex).format('MM');

    this.selectedDate = `${year}-${month}`;
  }

  setDismiss() {
    this.activeModal.dismiss();
  }

  setClose() {
    this.activeModal.close();
  }

  setDate() {
    this.emitData.next( this.selectedDate );
    this.setClose();
  }
}
